import DrugApi from '../api/drug';
import config from '../config';
import DrugPrescription from '../models/drug/prescription';
import DrugTime from '../models/drug/time';

const {url, timeout} = config.api.drug;
const drugApi = new DrugApi(url, timeout);

const state = {
  prescriptions: {},
  times: [],
};

const getters = {
  clientDrugPrescriptions: state => clientId => {
    if (!state.prescriptions[clientId]) {
      return [];
    }

    return state.prescriptions[clientId];
  },
};

const mutations = {
  DRUG_SET_PRESCRIPTIONS: (state, payload) => {
    state.prescriptions[payload.clientId] = payload.items.map(i => (new DrugPrescription(i)));
    state.prescriptions = Object.assign({}, state.prescriptions);
  },

  DRUG_SET_TIMES: (state, payload) => {
    state.times = payload.items.map(i => (new DrugTime(i)));

    state.times.sort((a, b) => a.sort - b. sort);
  },
};

const actions = {
  DRUG_LOAD_PRESCRIPTIONS: async (context, payload) => {
    const token = context.rootState.token;
    const result = await drugApi.getPrescriptions(token, payload);
    const data = { items: result.items, clientId: payload };

    context.commit('DRUG_SET_PRESCRIPTIONS', data);
  },

  DRUG_LOAD_TIMES: async (context) => {
    const token = context.rootState.token;
    const data = await drugApi.getTimes(token);

    context.commit('DRUG_SET_TIMES', data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
